/**
 * Route for `faster-reporting-via-columnar-backend`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FasterReportingViaColumnarBackendPage } from "../features/faster-reporting-via-columnar-backend/FasterReportingViaColumnarBackendPage";

export const fasterReportingViaColumnarBackendRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/faster-reporting-via-columnar-backend",
	component: FasterReportingViaColumnarBackendPage,
});

export default fasterReportingViaColumnarBackendRoute;
